import { render } from "./HealthData.vue?vue&type=template&id=48178863&scoped=true"
import script from "./HealthData.vue?vue&type=script&lang=js"
export * from "./HealthData.vue?vue&type=script&lang=js"

import "./HealthData.vue?vue&type=style&index=0&id=48178863&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48178863"]])

export default __exports__